import React, { Component } from 'react';
//import { NavLink } from "react-router-dom"
import { authentication } from '../services/Authentication';

import moment from 'moment';
import helpers from '../Function';
import { config } from '../Constants';
import Modal from "react-bootstrap/Modal";
import ModalBody from "react-bootstrap/ModalBody";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalFooter from "react-bootstrap/ModalFooter";
import ModalTitle from "react-bootstrap/ModalTitle";
import CircularProgress from '@material-ui/core/CircularProgress';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import Checkbox from '@material-ui/core/Checkbox';

import { Editor } from '@tinymce/tinymce-react';
import $ from "jquery"

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import ReactExport from "react-export-excel";
import QRCode from "react-qr-code";

import {ValidateImageMatchSize} from '../utils/validateImage';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


export default class PrivilegeEvent extends Component {

    constructor(props) {
        super(props);
        const { name, user_id, user_type, jwt, user_permission } = authentication.currentUserValue;

        this.state = {
            apiKey: process.env.TINY,
            pages: [],
            userid: user_id,
            content_id: '',
            jwt: jwt,
            user_permission: user_permission,
            create_by: name,
            create_by_id: user_id,
            usertype: user_type,
            addIsOpen: false,
            srcIsOpen: false,
            updateIsOpen: false,
            QRCodeIsOpen: false,
            add_id: '',
            add_title: '',
            add_content: '',
            add_active_status: '',
            add_active_register: '',
            add_linkRegister: '',
            add_start_date: '',
            add_end_date: '',
            add_point_join: '0',
            add_point_reward: '0',
            add_max_join: '0',
            add_limit: '0',
            add_limit_status: true,
            add_img: '',
            add_link: '',
            value: "content",
            status: '1',
            src_content: false,
            src_link: false,
            src_active: false,
            src_nonactive: false,
            active: true,
            registerActive: false, // register flag
            file: null,
            page: 0,
            rowsPerPage: 10,
            miss_su: helpers.getUserType(user_type, "su"),
            previewIsOpen: false,
            previewImage: null,
            spinner: true,
        };

        $("#root").addClass("wrapper");
        $("body").removeClass("login-page");

        this.dataTable = this.dataTable.bind(this);

        this.closeAdd = this.closeAdd.bind(this);
        this.openAdd = this.openAdd.bind(this);
        this.openView = this.openView.bind(this);
        this.submitAdd = this.submitAdd.bind(this);

        this.change = this.change.bind(this);
        this.openEdit = this.openEdit.bind(this);
        this.submitEdit = this.submitEdit.bind(this);
        this.openSrc = this.openSrc.bind(this);
        this.submitSrc = this.submitSrc.bind(this);
        this.closeSrc = this.closeSrc.bind(this);

        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
        this.handleChange = this.handleChange.bind(this)
        this.handleCheck = this.handleCheck.bind(this)
        this.handleCheckRegister = this.handleCheckRegister.bind(this)
        this.onChange = this.onChange.bind(this);

        this.closeModelUpdate = this.closeModelUpdate.bind(this);

        this.openDelete = this.openDelete.bind(this);
        this.closeDelete = this.closeDelete.bind(this);
        this.submitDelete = this.submitDelete.bind(this);

        this.handleActiveSrcCheck = this.handleActiveSrcCheck.bind(this)
        this.handleNonActiveSrcCheck = this.handleNonActiveSrcCheck.bind(this)
        this.handleContentSrcCheck = this.handleContentSrcCheck.bind(this)
        this.handleLinkSrcCheck = this.handleLinkSrcCheck.bind(this)

        this.openPreview = this.openPreview.bind(this);
        this.closePreview = this.closePreview.bind(this);
        
        this.openQRCode = this.openQRCode.bind(this);   
        this.closeModelQRCode = this.closeModelQRCode.bind(this);
        this.handleChangeNumber = this.handleChangeNumber.bind(this);
        this.handleCheckLimit = this.handleCheckLimit.bind(this)
        

    }

    handleCheckLimit() {
        this.setState({ add_limit_status: !this.state.add_limit_status });
        this.setState({ add_limit: !this.state.add_limit_status ? 'ไม่จำกัด':'0' });
    }

    handleChangeNumber = (event) => {
        let { value } = event.target;
        value = value.replace(/\D/g,''); // Remove all non-digit characters
        if (value === '') {
          this.setState({ [event.target.name]: '0' });
        } else {
          this.setState({ [event.target.name]: parseInt(value).toLocaleString() });
        }
    };

    componentDidMount() {
        helpers.checklogin(this.state.jwt);
        this.dataTable();
    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    submitAdd() {
        try {

            this.setState({spinner:true})

            if (!this.state.add_title) {
                alert('ไม่พบข้อมูลหัวเรื่อง');
                return;
            }
    
            if (!this.state.add_content && this.state.value === 'content') {
                alert('ไม่พบข้อมูลเนื้อหา');
                return;
            }
    
            if (!this.state.add_link && this.state.value === 'link') {
                alert('ไม่พบข้อมูลลิ้ง');
                return;
            }
    
            if (!this.state.add_start_date) {
                alert('ไม่พบข้อมูลวันเริ่มต้น');
                return;
            }
    
            if (!this.state.add_end_date) {
                alert('ไม่พบข้อมูลวันสิ้นสุด');
                return;
            }
            
            if (!this.state.active) {
                this.setState({
                    active: true
                });
            }
    
            if (!this.state.file) {
                alert('ไม่พบข้อมูลรูปภาพ');
                return;
            }
    
            if (!this.state.add_no) {
                alert('ไม่พบข้อมูลลำดับ');
                return;
            }
    
            if(!this.state.add_point_join){
                alert('ไม่พบข้อมูลพอยท์ในการเข้าร่วม');
                return;
            }
    
            if(!this.state.add_point_reward){
                alert('ไม่พบข้อมูลพอยท์ที่ได้รับรางวัล');
                return;
            }
    
            if(!this.state.add_max_join){
                alert('ไม่พบข้อมูลจำนวนสิทธิเข้าร่วม');
                return;
            }
    
            const formData = new FormData();
            formData.append('title', this.state.add_title);
            formData.append('content', this.state.add_content);
            formData.append('link', this.state.add_link);
            formData.append('type_content', this.state.value);
            formData.append('active', this.state.active);
            formData.append('register_flag', this.state.registerActive);
            formData.append('register_link', this.state.add_linkRegister);
            formData.append('start_date', this.state.add_start_date);
            formData.append('end_date', this.state.add_end_date);
            // formData.append('point_join', helpers.removeFormatNumber(this.state.add_point_join) );
            // formData.append('point_reward', helpers.removeFormatNumber(this.state.add_point_reward) );
            // formData.append('max_join', helpers.removeFormatNumber(this.state.add_max_join) );
            formData.append('createby', this.state.create_by);
            formData.append('createby_id', this.state.create_by_id);
            formData.append('myImage', this.state.file);
            formData.append('no', this.state.add_no);

            formData.append('point_join', helpers.removeFormatNumber(this.state.add_point_join) );
            formData.append('point_reward', helpers.removeFormatNumber(this.state.add_point_reward) );
            formData.append('max_join', helpers.removeFormatNumber(this.state.add_max_join) );

            const limit_per_user = this.state.add_limit;
            const parsedLimit = parseFloat(limit_per_user);
            const isValidNumber = !isNaN(parsedLimit);
            const finalLimit = isValidNumber ? parsedLimit : 0;
            formData.append('limit_per_user', finalLimit  );
            formData.append('is_limit', this.state.add_limit_status);
    
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Authorization': this.state.jwt,
                },
                body: formData
            };
    
            fetch(config.url.API_URL + '/createEventDetail', requestOptions)
                .then(res => res.json())
                .then(data => {
                    this.setState({
                        updateIsOpen: true,
                        file: null,
                        spinner: false
                    });
                }).catch(error => {
                    console.log(error)
                    this.setState({spinner:false})
                    //window.location.reload(); // Reload the page
                })
    
            this.setState({ addIsOpen: false });
        } catch (error) {
            console.log(error)
            this.setState({spinner:false})
            //window.location.reload(); // Reload the page
        }
    }

    dataTable() {
        try {

            this.setState({spinner:true})

            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/getEventDetail', requestOptions)
                .then(res => res.json())
                .then(data => {
                    if (Array.isArray(data.data) && data.data.length) {
                        this.setState({
                            pages: [].concat(data.data),
                            spinner:false
                        });
    
                    } else {
                        this.setState({
                            pages: [],
                            spinner:false
                        });
                    }
    
                }).catch(error => {
                    console.log(error)
                    this.setState({spinner:false})
                    // //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            this.setState({spinner:false})
            // //window.location.reload(); // Reload the page
        }
    }

    openAdd() {
        this.setState({
            add_title: '',
            add_content: '',
            add_active_status: '',
            add_active_register: '',
            add_linkRegister: '',
            add_start_date: '',
            add_end_date: '',
            add_point_join: '0',
            add_point_reward: '0',
            add_max_join: '0',
            add_limit: '0',
            add_limit_status: true,
            add_img: '',
            add_link: '',
            file: null,
            value: "content",
            active: true,
            registerActive: false,
            addIsOpen: true,
            methodOpen: 'add',
            previewImage:null,
            add_no: '',
        });
    }

    openDelete(e) {
        this.setState({
            deleteIsOpen: true,
            content_id: e.currentTarget.attributes["data-id"].value
        });
    }

    openQRCode(e) {
        this.setState({
            add_id: e.currentTarget.attributes["data-id"].value,
            QRCodeIsOpen: true,
        });
    }

    closeModelQRCode(){
        this.setState({
            QRCodeIsOpen: false,
        });
    }

    openView(e) {
        try {

            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/getEventDetail/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataDetail => {
                    var data = dataDetail.data;
    
                    this.setState({
                        add_id: data.id,
                        add_title: data.title,
                        add_content: data.content,
                        add_active_status: data.active_status,
                        add_active_register: data.register_status,
                        add_start_date: moment(data.start_date).format("DD/MM/YYYY"),
                        add_end_date: moment(data.end_date).format("DD/MM/YYYY"),
                        add_point_join: data.point_join,
                        add_point_reward: data.point_reward,
                        add_max_join: data.max_join,
                        add_limit_status: data.is_limit,
                        add_limit: data.is_limit == true ? "ไม่จำกัด" : data.limit_per_user,
                        add_img: data.img,
                        value: data.type_content,
                        add_link: data.link,
                        registerActive: data.registerActive,
                        add_linkRegister: data.register_link,
                        add_no: data.no
                    });
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'view',
                    });
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitDelete(e) {
        try {
            this.setState({spinner:true})
            const requestOptions = {
                method: 'PUT',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
                body: JSON.stringify({
                    updateby: this.state.create_by,
                    updateby_id: this.state.create_by_id
                }),
            };
    
            fetch(config.url.API_URL + '/deleteEventDetail/' + this.state.content_id, requestOptions)
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    if(data.status != "Success"){
                        alert('Failed to Connect')
                        this.setState({spinner:false})
                    }else{
                        this.setState({
                            updateIsOpen: true,
                            spinner: false
                        });
                    }
    
                }).catch(error => {
                    console.log(error)
                    this.setState({spinner:false})
                    //window.location.reload(); // Reload the page
                })
    
            this.setState({ deleteIsOpen: false });
        } catch (error) {
            console.log(error)
            this.setState({spinner:false})
            //window.location.reload(); // Reload the page
        }
    }

    closeAdd() {
        this.setState({ addIsOpen: false });
    }

    closeDelete() {
        this.setState({ deleteIsOpen: false });
        this.dataTable();
    }

    openEdit(e) {
        try {

            const requestOptions = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            fetch(config.url.API_URL + '/getEventDetail/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(dataDetail => {
                    var data = dataDetail.data;
                    this.setState({
                        add_id: data.id,
                        add_title: data.title,
                        add_content: data.content,
                        add_active_status: data.active_status,
                        add_active_register: data.active_register,
                        add_start_date: new Date(data.start_date),
                        add_end_date: new Date(data.end_date),
                        add_point_join: data.point_join,
                        add_point_reward: data.point_reward ,
                        add_max_join: data.max_join ,
                        add_limit_status: data.is_limit,
                        add_limit: data.is_limit == true ? "ไม่จำกัด" : data.limit_per_user,
                        active: data.active,
                        value: data.type_content,
                        add_link: data.link,
                        registerActive: data.registerActive,
                        add_linkRegister: data.register_link,
                        add_no: data.no,
                        previewImage: data.img
                    });
    
                    this.setState({
                        addIsOpen: true,
                        methodOpen: 'edit',
                    });
    
                }).catch(error => {
                    console.log(error)
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            //window.location.reload(); // Reload the page
        }
    }

    submitEdit(e) {
        try {

            this.setState({spinner:true})

            if (!this.state.add_no) {
                alert('ไม่พบข้อมูลลำดับ');
                return;
            }
    
            const formData = new FormData();
            formData.append('title', this.state.add_title);
            formData.append('content', this.state.add_content);
            formData.append('link', this.state.add_link);
            formData.append('type_content', this.state.value);
            formData.append('active', this.state.active);
            formData.append('register_flag', this.state.registerActive);
            formData.append('register_link', this.state.add_linkRegister);
            formData.append('start_date', this.state.add_start_date);
            formData.append('end_date', this.state.add_end_date);

            formData.append('updateby', this.state.create_by);
            formData.append('updateby_id', this.state.create_by_id);
            formData.append('myImage', this.state.file);
            formData.append('no', this.state.add_no);


            formData.append('point_join', helpers.removeFormatNumber(this.state.add_point_join) );
            formData.append('point_reward', helpers.removeFormatNumber(this.state.add_point_reward) );
            formData.append('max_join', helpers.removeFormatNumber(this.state.add_max_join) );

            // formData.append('point_join', this.state.add_point_join);
            // formData.append('point_reward', this.state.point_reward);
            // formData.append('max_join', this.state.max_join);

            console.log(this.state.add_limit)
            const limit_per_user = this.state.add_limit;
            const parsedLimit = parseFloat(limit_per_user);
            const isValidNumber = !isNaN(parsedLimit);
            const finalLimit = isValidNumber ? parsedLimit : 0;
            formData.append('limit_per_user', finalLimit  );
            formData.append('is_limit', this.state.add_limit_status);

            const requestOptions = {
                method: 'PUT',
                headers: {
                    'Authorization': this.state.jwt,
                },
                body: formData
            };
    
            fetch(config.url.API_URL + '/updateEventDetail/' + e.currentTarget.attributes["data-id"].value, requestOptions)
                .then(res => res.json())
                .then(data => {
                    if(data.status != "Success"){
                        alert('Failed to Connect')
                        this.setState({spinner:false})
                    }else{
                        this.setState({
                            updateIsOpen: true,
                            spinner:false
                        });
                    }
                }).catch(error => {
                    console.log(error)
                    this.setState({spinner:false})
                    //window.location.reload(); // Reload the page
                })
    
            this.setState({ addIsOpen: false });
        } catch (error) {
            console.log(error)
            this.setState({spinner:false})
            //window.location.reload(); // Reload the page
        }
    }

    submitSrc(e) {
        this.dataTableSrc()
        this.setState({ srcIsOpen: false });
    }

    dataTableSrc() {
        try {

            this.setState({spinner:true})

            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.state.jwt,
                },
            };
    
            var body = `?active=${this.state.src_active}&nonactive=${this.state.src_nonactive}&content=${this.state.src_content}&link=${this.state.src_link}&title=${this.state.add_title}&startdate=${this.state.add_start_date}&enddate=${this.state.add_end_date}`
    
            fetch(config.url.API_URL + '/getEventDetailSrc' + body, requestOptions)
                .then(res => res.json())
                .then(data => {
                    if (Array.isArray(data.data) && data.data.length) {
                        this.setState({
                            pages: [].concat(data.data),
                            spinner: false
                        });
    
                    } else {
                        this.setState({
                            pages: [],
                            spinner: false
                        });
                    }
    
                }).catch(error => {
                    console.log(error)
                    this.setState({spinner:false})
                    //window.location.reload(); // Reload the page
                })
        } catch (error) {
            console.log(error)
            this.setState({spinner:false})
            //window.location.reload(); // Reload the page
        }
    }

    closeSrc() {
        this.setState({ srcIsOpen: false });
    }

    openSrc(e) {
        this.setState({
            srcIsOpen: true,
            src_content: false,
            src_link: false,
            src_active: false,
            src_nonactive: false,
            add_type: '',
            add_title: '',
            add_link: '',
            add_linkRegister: '',
            add_start_date: '',
            add_end_date: '',
            add_point_join: '',
            add_point_reward: '',
            add_max_join: '',
            add_sub: '',
            page: 0
        });
    }

    closeModelUpdate() {
        this.setState({ updateIsOpen: false });
        this.dataTable();
    }

    
    handleChangePage(event, newPage) {
        this.setState({
            page: newPage
        });
    };

    handleChangeRowsPerPage(event) {
        //alert(event.target.value)
        this.setState({
            page: 0,
            rowsPerPage: parseInt(event.target.value)
        });
    };

    handleChange(event) {
        this.setState({ add_content: event.target.value });
    }

    changeStartDate = date => {
        this.setState({
            add_start_date: date
        });
    }

    changeEndDate = date => {
        this.setState({
            add_end_date: date
        });
    }

    handleCheck() {
        this.setState({ active: !this.state.active });
    }

    handleCheckRegister() {
        this.setState({ registerActive: !this.state.registerActive });
    }

    onChange(e) {

        const file = e.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onloadend = () => {
            this.setState({ previewImage: reader.result });
          };
          reader.readAsDataURL(file);
        }else{
            this.setState({previewImage:null,file:null})
        }
        const fileName = e.target.files[0]
        this.setState({ file: fileName })


        // const validateOption = {
        //     width: 1120,
        //     height: 720,
        // }

        // ValidateImageMatchSize(fileName, validateOption)
        //     .then(()=>this.setState({ file: fileName }))
        //     .catch(err => {
        //         document.getElementsByName('myImage')[0].value = null
        //         alert(err)
        //     })
    }

    handleEditorChange = (content, editor) => {
        this.setState({
            add_content: content
        });
        console.log('Content was updated:', content);
    }

    handleEditorBlur = async (content, editor) => {
        const data = await editor.getContent();
        this.setState({
            add_content: data
        });
        console.log('Content was updated:', data);

    }

    handleContentTypeChange = (event) => {
        this.setState({
            value: event.target.value,
            registerActive: false
        })
    };

    handleActiveSrcCheck() {
        this.setState({
            src_active: !this.state.src_active
        });
    }

    handleNonActiveSrcCheck() {
        this.setState({
            src_nonactive: !this.state.src_nonactive
        });
    }

    handleContentSrcCheck() {
        this.setState({
            src_content: !this.state.src_content
        });
    }

    handleLinkSrcCheck() {
        this.setState({
            src_link: !this.state.src_link
        });
    }

    openPreview() {
        this.setState({
            previewIsOpen: true,
        });
    }

    closePreview() {
        this.setState({ previewIsOpen: false });
    }

    render() {

        const StyledTableCell = withStyles(theme => ({
            head: {
                backgroundColor: "#E8EFF5",
                color: "#212529",
                fontSize: 20,
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                textAlign: 'center',
            },
            body: {
                fontSize: 18,
                verticalAlign: 'text-top',
                fontFamily: 'db_heaventmed_cond',
                border: '1px solid rgba(224, 224, 224, 1)',
                padding: 8,
            },
        }))(TableCell);

        const StyledTableRow = withStyles(theme => ({
            root: {
                '&:nth-of-type(odd)': {
                    backgroundColor: theme.palette.background.default,
                },
            },
        }))(TableRow);

        const emptyRows = this.state.rowsPerPage - Math.min(this.state.rowsPerPage, this.state.page.length - this.state.page * this.state.rowsPerPage);

        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 text-dark">Event</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">Event</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="btn-advance text-center" onClick={this.openSrc}>ค้นหาขั้นสูง</div>
                                    {(this.state.user_permission[234].permission == 1 && <div className="btn-add text-center" onClick={this.openAdd}>เพิ่มข้อมูล</div>)}
                                    <ExcelFile filename="event" element={(
                                        <div className="btn-add text-center">Export Data</div>
                                    )}>
                                        <ExcelSheet data={this.state.pages} name="event">
                                            <ExcelColumn label="หัวเรื่อง" value={(col) => col.title} />
                                            <ExcelColumn label="เนื้อหา" value={(col) => col.content} />
                                            <ExcelColumn label="ลิงก์" value={(col) => col.link} />
                                            <ExcelColumn label="ภาพหน้าปก" value={(col) => col.img} />
                                            <ExcelColumn label="วันที่เริ่มต้น" value={(col) => col.start_date} />
                                            <ExcelColumn label="วันที่สิ้นสุด" value={(col) => col.end_date} />
                                            <ExcelColumn label="วันที่สร้าง" value={(col) => col.create} />
                                            <ExcelColumn label="อัพเดทล่าสุด" value={(col) => col.updateby} />
                                            <ExcelColumn label="อัพเดทล่าสุด(เวลา)" value={(col) => col.updated} />
                                        </ExcelSheet>
                                    </ExcelFile>
                                </div>
                                <div className="card-body">
                                {
                                        this.state.spinner && <div style={{ textAlign: 'center' }}><CircularProgress /></div>
                                    }
                                    {
                                        !this.state.spinner && <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: 'auto' }}>No</StyledTableCell>
                                                    <StyledTableCell style={{ width: '200px' }}>หัวเรื่อง</StyledTableCell>
                                                    <StyledTableCell style={{ width: 'auto' }}>ภาพหน้าปก</StyledTableCell>
                                                    <StyledTableCell style={{ width: '200px' }}>วันที่เริ่ม - วันที่สิ้นสุด</StyledTableCell>
                                                    <StyledTableCell style={{ width: '150px' }}>สถานะการใช้งาน</StyledTableCell>
                                                    <StyledTableCell style={{ width: '200px' }}>วันที่สร้าง</StyledTableCell>
                                                    <StyledTableCell style={{ width: '200px' }}>อัพเดทล่าสุด</StyledTableCell>
                                                    <StyledTableCell style={{ width: '100px' }}>รายละเอียด</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    this.state.pages.slice(this.state.page * this.state.rowsPerPage,
                                                        this.state.page * this.state.rowsPerPage + this.state.rowsPerPage).map((data, i) => {
                                                            return (
                                                                <StyledTableRow key={`1${i}`}>
                                                                    <StyledTableCell style={{ textAlign: 'center' }}>{data.num}</StyledTableCell>
                                                                    <StyledTableCell>{data.title}</StyledTableCell>
                                                                    <StyledTableCell style={{ textAlign: 'center' }}><img src={data.img} alt="pic" height="100" width="auto" style={{ verticalAlign: "text-top" }} /></StyledTableCell>
                                                                    <StyledTableCell>{data.start_date} - {data.end_date}</StyledTableCell>
                                                                    <StyledTableCell>{data.active_status}</StyledTableCell>
                                                                    <StyledTableCell>{data.create}</StyledTableCell>
                                                                    <StyledTableCell>{data.updateby}<br />{data.updateby != undefined ? data.updated : ""}</StyledTableCell>
                                                                    <StyledTableCell>
                                                                        {/* <button className="btn-action text-center" data-id={data.id} onClick={this.openQRCode}>QR Code</button> */}
                                                                        <button className="btn-action text-center" data-id={data.id} onClick={this.openView}><img src="dist/img/icon/ic_view.png" className="btn-icon" alt="" />View</button>

                                                                        {(this.state.user_permission[106].permission == 1 &&
                                                                            <button className="btn-action text-center" data-id={data.id} onClick={this.openEdit}><img src="dist/img/icon/ic_update.png" className="btn-icon" alt="" /> Update</button>
                                                                        )}
                                                                        {(this.state.user_permission[107].permission == 1 &&
                                                                            <button className="btn-action text-center" data-id={data.id} onClick={this.openDelete}><img src="dist/img/icon/ic_del.png" className="btn-icon" alt="" /> Delete</button>
                                                                        )}
                                                                    </StyledTableCell>
                                                                </StyledTableRow>)
                                                        })
                                                }

                                                {emptyRows > 0 && (
                                                    <StyledTableRow>
                                                        <StyledTableCell colSpan={6} />
                                                    </StyledTableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[10, 25, 50]}
                                            component="div"
                                            count={this.state.pages.length}
                                            rowsPerPage={this.state.rowsPerPage}
                                            page={this.state.page}
                                            onChangePage={this.handleChangePage}
                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        />
                                    </TableContainer>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Modal show={this.state.addIsOpen} onHide={this.closeAdd} size="xl" enforceFocus={false}>
                    <ModalHeader>
                        <ModalTitle>{(this.state.methodOpen === 'add' && "เพิ่มข้อมูล") || (this.state.methodOpen === 'edit' && "แก้ไขข้อมูล") || (this.state.methodOpen === 'view' && "ตรวจสอบข้อมูล")}</ModalTitle>
                        {((this.state.value == 'content' && this.state.add_content != "") &&  <div className="text-right"><button type="button" className="btn btn-outline-dark text-center btn-sm" onClick={this.openPreview}><img src="dist/img/icon/mobile_preview.png" alt="" width={"15px"} height={"auto"}/></button></div> )}
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-submit">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">หัวเรื่อง<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<TextareaAutosize className="form-control" id="add_title" name="add_title" rowsMin={1} defaultValue={this.state.add_title} onChange={this.change} />)
                                        : (<TextareaAutosize className="form-control" id="add_title" name="add_title" rowsMin={1} defaultValue={this.state.add_title} onChange={this.change} disabled/>)}
                                </div>
                            </div>
                            <div className="row mb-3" >
                                <div className="col-sm-3 text-right">ประเภทการแสดงผล</div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<div><RadioGroup aria-label="contenttype" name="contenttype" value={this.state.value} onChange={this.handleContentTypeChange} style={{ display: 'flex', flexDirection: 'row' }}>
                                            <div><FormControlLabel value="content" control={<Radio color="primary" />} label={<span style={{ fontFamily: "db_heaventmed_cond", fontSize: "20px" }}>เนื้อหา</span>} /></div>
                                            <div><FormControlLabel value="link" control={<Radio color="primary" />} label={<span style={{ fontFamily: "db_heaventmed_cond", fontSize: "20px" }}>ลิงก์</span>} /></div>
                                        </RadioGroup></div>)
                                        : (<div><RadioGroup aria-label="contenttype" name="contenttype" value={this.state.value} onChange={this.handleContentTypeChange} style={{ display: 'flex', flexDirection: 'row' }}>
                                            <div><FormControlLabel value="content" control={<Radio color="primary" />} label={<span style={{ fontFamily: "db_heaventmed_cond", fontSize: "20px" }}>เนื้อหา</span>} disabled /></div>
                                            <div><FormControlLabel value="link" control={<Radio color="primary" />} label={<span style={{ fontFamily: "db_heaventmed_cond", fontSize: "20px" }}>ลิงก์</span>} disabled /></div>
                                        </RadioGroup></div>)}
                                </div>
                            </div>
                            {(this.state.value === 'content') ? (<div className="row mb-3">
                                <div className="col-sm-3 text-right">เนื้อหา<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-9">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<Editor
                                            apiKey={this.state.apiKey}
                                            initialValue={this.state.add_content}
                                            init={{
                                                width: "auto",
                                                height: 300,
                                                plugins: [
                                                    "autoresize",
                                                    'advlist autolink link image lists preview',
                                                    'searchreplace wordcount visualblocks visualchars code media emoticons',
                                                    'table template paste help'
                                                ],
                                                toolbar: 'undo redo | styleselect | emoticons | bold italic | alignleft aligncenter alignright alignjustify | ' +
                                                    'bullist numlist outdent indent | link image | preview media | ' +
                                                    'forecolor backcolor | help',
                                                menubar: 'edit view insert format tools table',  // change this value according to your HTML
                                                automatic_uploads: true,
                                                images_upload_handler: function (blobInfo, success, failure) {
                                                    var xhr, formData;
                                                    xhr = new XMLHttpRequest();
                                                    xhr.withCredentials = false;
                                                    xhr.open('POST', `${config.url.API_URL}/uploadImage/`);
                                                    xhr.onload = function () {
                                                        var json;

                                                        if (xhr.status !== 200) {
                                                            failure('HTTP Error: ' + xhr.status);
                                                            return;
                                                        }
                                                        json = JSON.parse(xhr.responseText);

                                                        if (!json || typeof json.location != 'string') {
                                                            failure('Invalid JSON: ' + xhr.responseText);
                                                            return;
                                                        }
                                                        success(json.location);
                                                    };
                                                    formData = new FormData();
                                                    formData.append('myImage', blobInfo.blob());
                                                    xhr.send(formData);
                                                },
                                                content_css: '//www.tiny.cloud/css/codepen.min.css',
                                                autoresize_on_init: false,
                                                autoresize_overflow_padding: 10
                                            }}
                                            onBlur={this.handleEditorBlur}
                                            // onEditorChange={this.handleEditorChange}
                                        />)
                                        : (<Editor
                                            apiKey={this.state.apiKey}
                                            initialValue={this.state.add_content}
                                            init={{
                                                width: "auto",
                                                height: 300,
                                                plugins: ["autoresize",
                                                    'advlist autolink link image lists preview',
                                                    'searchreplace wordcount visualblocks visualchars code media emoticons',
                                                    'table template paste help'
                                                ],
                                                toolbar: 'undo redo | styleselect | emoticons | bold italic | alignleft aligncenter alignright alignjustify | ' +
                                                    'bullist numlist outdent indent | link image | preview media | ' +
                                                    'forecolor backcolor | help',
                                                menubar: 'edit view insert format tools table',
                                                content_css: '//www.tiny.cloud/css/codepen.min.css',
                                                autoresize_on_init: false,
                                                autoresize_overflow_padding: 10
                                            }}
                                            onEditorChange={this.handleEditorChange}
                                            disabled={true}
                                        />)}
                                </div>
                            </div>) : (
                                    <div className="row mb-3">
                                        <div className="col-sm-3 text-right">link<span style={{ color: 'red' }}>*</span></div>
                                        <div className="col-sm-5">
                                            {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<TextareaAutosize className="form-control" id="add_link" name="add_link" rowsMin={1} defaultValue={this.state.add_link} onChange={this.change}  />)
                                        : (<TextareaAutosize className="form-control" id="add_link" name="add_link" rowsMin={1} defaultValue={this.state.add_link} onChange={this.change} disabled/>)}
                                        </div>
                                    </div>)
                            }
                            {/* {(this.state.value === 'content') ? (<div className="row mb-3">
                                <div className="col-sm-3 text-right">การลงทะเบียน<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<p><Checkbox
                                            checked={this.state.registerActive}
                                            onChange={this.handleCheckRegister}
                                            color="primary"
                                        />ลงทะเบียน</p>)
                                        : (<div>
                                            <p>{this.state.add_active_register}</p>
                                        </div>)}
                                </div>
                            </div>) : ""
                            } */}
                            {(this.state.registerActive) ? (
                                <div className="row mb-3">
                                    <div className="col-sm-3 text-right" >link ลงทะเบียน<span style={{ color: 'red' }}>*</span></div>
                                    <div className="col-sm-5" >
                                        {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                            (<input type="text"  className="form-control" id="add_linkRegister" name="add_linkRegister" defaultValue={this.state.add_linkRegister} onChange={this.change} />)
                                            : (<div style={{'textOverflow': 'ellipsis', overflow:'hidden', 'whiteSpace': 'nowrap' }}  className="form-control">{this.state.add_linkRegister}</div>)}
                                    </div>
                                </div>) : ""}
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ภาพหน้าปก<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-9">
                                {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ? (
                                    <>
                                        {this.state.previewImage && (
                                        <div>
                                            <img src={this.state.previewImage} alt="preview" width="200" height="auto" style={{ObjectFit:'cover'}} />
                                        </div>
                                        )}
                                        <div>
                                            <input type="file" name="myImage" onChange={this.onChange} accept="image/png, image/jpeg" />
                                        </div>

                                    </>
                                    ) : (
                                        <>
                                        {this.state.add_img && (<img src={this.state.add_img} alt="pic" width="200" height="auto" style={{ObjectFit:'cover'}}/>)}
                                        </>                                    
                                )}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-7 text-right"><span style={{ color: 'rgb(247, 188, 11)', fontSize: '18px' }}>*หมายเหตุ :แนะนำไฟล์ JPG, PNG ขนาด 1120*720px</span></div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">วันที่เริ่มต้น<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.add_start_date} id="start_date" onChange={this.changeStartDate} name="start_date" className="form-control" dateFormat="dd/MM/yyyy" />)
                                        : (<div className="form-control">{this.state.add_start_date}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">วันที่สิ้นสุด<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.add_end_date} id="end_date" onChange={this.changeEndDate} name="end_date" className="form-control" dateFormat="dd/MM/yyyy" />)
                                        : (<div className="form-control">{this.state.add_end_date}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                    <div className="col-sm-3 text-right">พอยท์ในการเข้าร่วม<span style={{ color: 'red' }}>*</span></div>
                                        <div className="col-sm-5">
                                            {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                                (<input type="text" 
                                                    className="form-control" 
                                                    id="add_point_join" 
                                                    name="add_point_join" 
                                                    value={this.state.add_point_join} 
                                                    onChange={this.handleChangeNumber}
                                                    onKeyPress={(event) => {
                                                    const keyCode = event.which ? event.which : event.keyCode;
                                                    const keyValue = String.fromCharCode(keyCode);
                                                    if (!/^\d+$/.test(keyValue)) {
                                                        event.preventDefault();
                                                    }
                                                    }}
                                                />)
                                                : (<div className="form-control">{this.state.add_point_join}</div>)}
                                    </div>
                            </div>
                            <div className="row mb-3">
                                    <div className="col-sm-3 text-right">พอยท์ที่ได้รับรางวัล<span style={{ color: 'red' }}>*</span></div>
                                        <div className="col-sm-5">
                                            {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                                (<input type="text" className="form-control" id="add_point_reward" name="add_point_reward" value={this.state.add_point_reward} 
                                                    onChange={this.handleChangeNumber}
                                                    onKeyPress={(event) => {
                                                    const keyCode = event.which ? event.which : event.keyCode;
                                                    const keyValue = String.fromCharCode(keyCode);
                                                    if (!/^\d+$/.test(keyValue)) {
                                                        event.preventDefault();
                                                    }
                                                }}
                                                />)
                                                : (<div className="form-control">{this.state.add_point_reward}</div>)}
                                    </div>
                            </div>
                            <div className="row mb-3">
                                    <div className="col-sm-3 text-right">จำนวนสิทธิเข้าร่วม<span style={{ color: 'red' }}>*</span></div>
                                        <div className="col-sm-5">
                                        {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                            (<input type="text" className="form-control" id="add_max_join" name="add_max_join" value={this.state.add_max_join}
                                            onChange={this.handleChangeNumber}
                                            onKeyPress={(event) => {
                                            const keyCode = event.which ? event.which : event.keyCode;
                                            const keyValue = String.fromCharCode(keyCode);
                                            if (!/^\d+$/.test(keyValue)) {
                                                event.preventDefault();
                                            }
                                            }}
                                         />)
                                        : (<div className="form-control">{this.state.add_max_join}</div>)}

                                            {/* {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                                (<input type="number" className="form-control" id="add_max_join" name="add_max_join" defaultValue={this.state.add_max_join} onChange={this.change} />)
                                                : (<div className="form-control">{this.state.add_max_join}</div>)} */}
                                    </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">จำกัดสิทธิ์<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-2" >
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" className="form-control" id="add_limit" name="add_limit" value={this.state.add_limit} disabled={this.state.add_limit_status}
                                        onChange={this.handleChangeNumber}
                                        onKeyPress={(event) => {
                                        const keyCode = event.which ? event.which : event.keyCode;
                                        const keyValue = String.fromCharCode(keyCode);
                                        if (!/^\d+$/.test(keyValue)) {
                                            event.preventDefault();
                                        }
                                        }}
                                         />)
                                        : (<div className="form-control">{this.state.add_limit}</div>)}
                                </div>
                                <div className="col-sm-1" style={{alignSelf:'center'}}> สิทธิ์ / ผู้ใช้งาน </div>
                                <div className="col-sm-3" style={{alignSelf:'center'}}> 
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ? (                                    <span>
                                        <Checkbox
                                                checked={this.state.add_limit_status}
                                                onChange={this.handleCheckLimit}
                                                color="primary"
                                            />ไม่จำกัด
                                    </span> ):(<></>)}

                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">ลำดับ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-2">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<input type="text" className="form-control" id="add_no" name="add_no" defaultValue={this.state.add_no} onChange={this.change} />)
                                        : (<div className="form-control">{this.state.add_no}</div>)}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">สถานะ<span style={{ color: 'red' }}>*</span></div>
                                <div className="col-sm-5">
                                    {(this.state.methodOpen === 'add') || (this.state.methodOpen === 'edit') ?
                                        (<p><Checkbox
                                            checked={this.state.active}
                                            onChange={this.handleCheck}
                                            color="primary"
                                        />ใช้งาน</p>)
                                        : (<div>
                                            <p>{this.state.add_active_status}</p>
                                        </div>)}
                                </div>
                            </div>
                        </form>
                    </ModalBody>
                    <ModalFooter>
                        {(this.state.methodOpen === 'add' &&
                            (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                <button className="btn btn-success" onClick={this.submitAdd}>เพิ่มข้อมูล</button></div>))
                            || (this.state.methodOpen === 'edit' &&
                                (<div><button className="btn btn-danger" onClick={this.closeAdd}>ยกเลิก</button>&nbsp;&nbsp;
                                    <button className="btn btn-warning" data-id={this.state.add_id} onClick={this.submitEdit}>แก้ไขข้อมูล</button></div>))
                            || (this.state.methodOpen === 'view' &&
                                (<div><button className="btn btn-success" onClick={this.closeAdd}>ตกลง</button></div>))}
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.srcIsOpen} onHide={this.closeSrc} size="lg">
                    <ModalHeader>
                        <ModalTitle>ค้นหาขั้นสูง</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <form id="form-serach">
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">หัวเรื่อง</div>
                                <div className="col-sm-5">
                                    <input type="text" className="form-control" id="add_title" name="add_title" defaultValue={this.state.add_title} onChange={this.change} />
                                </div>
                            </div>
                            <div className="row mb-3" >
                                <div className="col-sm-3 text-right">ประเภทการแสดงผล</div>
                                <div className="col-sm-5">
                                    <Checkbox
                                        checked={this.state.src_content}
                                        onChange={this.handleContentSrcCheck}
                                        color="primary"
                                    /> เนื้อหา
                                    <Checkbox
                                        checked={this.state.src_link}
                                        onChange={this.handleLinkSrcCheck}
                                        color="primary"
                                    /> ลิงก์
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">วันที่เริ่มต้น</div>
                                <div className="col-sm-5">
                                    <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.add_start_date} id="start_date" onChange={this.changeStartDate} name="start_date" className="form-control" dateFormat="dd/MM/yyyy" popperPlacement="top-end"
                                        popperModifiers={{
                                            offset: {
                                                enabled: true,
                                                offset: '5px, 10px'
                                            },
                                            preventOverflow: {
                                                enabled: true,
                                                escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                                                boundariesElement: 'viewport'
                                            },
                                            zIndex: {
                                              enabled: true,
                                              fn: (data) => {
                                                return { ...data, styles: { ...data.styles, zIndex: 999 } };
                                              },
                                            },
                                        }} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-sm-3 text-right">วันที่สิ้นสุด</div>
                                <div className="col-sm-5">
                                    <DatePicker autoComplete="off" placeholderText="DD/MM/YYYY" selected={this.state.add_end_date} id="end_date" onChange={this.changeEndDate} name="end_date" className="form-control" dateFormat="dd/MM/yyyy" popperPlacement="top-end"
                                        popperModifiers={{
                                            offset: {
                                                enabled: true,
                                                offset: '5px, 10px'
                                            },
                                            preventOverflow: {
                                                enabled: true,
                                                escapeWithReference: false, // force popper to stay in viewport (even when input is scrolled out of view)
                                                boundariesElement: 'viewport'
                                            },
                                            zIndex: {
                                              enabled: true,
                                              fn: (data) => {
                                                return { ...data, styles: { ...data.styles, zIndex: 999 } };
                                              },
                                            },
                                        }} />
                                </div>
                            </div>
                            <div className="row mb-3" >
                                <div className="col-sm-3 text-right">สถานะ</div>
                                <div className="col-sm-5">
                                    <Checkbox
                                        checked={this.state.src_active}
                                        onChange={this.handleActiveSrcCheck}
                                        color="primary"
                                    /> ใช้งาน
                                    <Checkbox
                                        checked={this.state.src_nonactive}
                                        onChange={this.handleNonActiveSrcCheck}
                                        color="primary"
                                    /> ไม่ใช้งาน
                                </div>
                            </div>
                        </form>

                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeSrc}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-success" onClick={this.submitSrc}>ค้นหาข้อมูล</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.updateIsOpen} onHide={this.closeModelUpdate} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        บันทึกรายการสำเร็จ
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeModelUpdate}>ตกลง</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.deleteIsOpen} onHide={this.closeDelete} size="s">
                    <ModalHeader>
                        <ModalTitle>แจ้งเตือน</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        ยืนยันการลบรายการหรือไม่
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closeDelete}>ยกเลิก</button>&nbsp;&nbsp;
                        <button className="btn btn-warning" onClick={this.submitDelete}>ยืนยัน</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.previewIsOpen} onHide={this.closePreview} size="s" scrollable="true">
                    <ModalBody>
                        <div dangerouslySetInnerHTML={{ __html: `<meta name='viewport' content='width=device-width,initial-scale=1,maximum-scale=1' />
                        <style type="text/css"> p img { width: 100%; height: auto; } </style>
                        <div style=" width: 95%; height: auto; padding-top: 2%; padding-left: 2.5%; padding-right: 2.5%; ">
                            ${this.state.add_content}
                        </div>` }} />
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-danger" onClick={this.closePreview}>ปิด</button>
                    </ModalFooter>
                </Modal>
                <Modal show={this.state.QRCodeIsOpen} onHide={this.closeModelQRCode} size="s">
                    <ModalHeader>
                        <ModalTitle>QRCode</ModalTitle>
                    </ModalHeader>
                    <ModalBody>
                        <center>
                            <QRCode value={config.url.API_APP+"/joinevent?event_id="+this.state.add_id} />
                        </center>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-success" onClick={this.closeModelQRCode}>ตกลง</button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}